import {useActions} from "../../../../hooks/useActions";
import {config} from "../../../../config";

function ProgressPaidCell({paid, item}: any) {
    const {setCardBigSize} = useActions();

    let seasonStrokeClass = ' seasonStrokeClass';

    return <> {(paid[item].reward === 'card') ?
        <div className={'progressRewardCard font-oswald-bold ' + seasonStrokeClass}
             onClick={() => {
                 setCardBigSize(paid[item].card);
             }}
             onContextMenu={(event) => {
                 event.preventDefault();
                 setCardBigSize(paid[item].card);
                 return false;
             }}
        >
            <img
                src={config.cdnUrl + "/img/cards/mini/" + paid[item].card.id + ".webp"}
                className="seasonProgressCardImg"
                loading="eager"
            />
            <div className={'progressRewardCardAmount'}>x1</div>
        </div>
        : (paid[item].reward === 'soul_stone') ?
            <div className={'progressRewardSoulStone font-oswald-bold' + seasonStrokeClass}>
                <div className={'progressRewardSoulStoneAmount'}>{paid[item].amount}</div>
            </div>
            :
            <div className={'progressRewardGem font-oswald-bold' + seasonStrokeClass}>
                <div className={'progressRewardGemAmount'}>{paid[item].amount}</div>
            </div>
    }
    </>
}

export default ProgressPaidCell;
